import '../index.css';

export default function Bonuses() {
  return (
    <section className="bonuses-section">
      <div className="section-inner">
        <h2 className="section-title gradient-text">
          🎁 BÔNUS EXCLUSIVOS
        </h2>
        <p className="section-subtitle">
          Receba TUDO isso de presente ao garantir sua extensão hoje!
        </p>
        <div style={{
          background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
          padding: '16px 24px',
          borderRadius: '12px',
          marginTop: '16px',
          marginBottom: '32px',
          border: '2px solid #fbbf24',
          boxShadow: '0 4px 20px rgba(245, 158, 11, 0.3)',
          animation: 'pulse 2s infinite'
        }}>
          <p style={{
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#ffffff',
            textAlign: 'center',
            margin: 0,
            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
          }}>
            ⚠️ ATENÇÃO: Os bônus são exclusivos apenas para assinantes do <span style={{ color: '#fef3c7', textDecoration: 'underline' }}>Plano Mensal</span> ou <span style={{ color: '#fef3c7', textDecoration: 'underline' }}>Plano Vitalício</span>
          </p>
        </div>

        <div className="bonuses-grid">
          {/* Bônus 1 - Google Drive */}
          <div className="bonus-card">
            <div className="bonus-image-wrapper">
              <img src="https://static.lumi.new/f3/f3cbad88e7908047d1af8ab1c823cede.webp" alt="Pasta Google Drive" className="bonus-image" />
            </div>
            <div className="bonus-content">
              <h3 className="bonus-title">📂 Pasta no Google Drive com Materiais e Prompts Extras</h3>
              <ul className="bonus-features">
                <li>✅ Prompts extras, hacks e truques ensinados nos vídeos do YouTube</li>
                <li>✅ Agentes GPTs especialistas em Lovable para acelerar seu desenvolvimento</li>
                <li>✅ Scripts para remover marca d'água do Lovable</li>
                <li>✅ Scripts de instruções para não perder créditos no Lovable</li>
                <li>✅ Muitos outros arquivos que serão adicionados constantemente</li>
              </ul>
              <div className="bonus-value">
                <span className="bonus-price-old">VALOR: R$29,90</span>
                <span className="bonus-price-free">GRÁTIS para você hoje!</span>
              </div>
            </div>
          </div>

          {/* Bônus 2 - Script Milionário */}
          <div className="bonus-card">
            <div className="bonus-image-wrapper">
              <img src="https://static.lumi.new/a0/a01ce8bc9b698527d81af3609080bcbc.webp" alt="Script Milionário" className="bonus-image" />
            </div>
            <div className="bonus-content">
              <h3 className="bonus-title">💰 Script Milionário: Landing Pages de Alta Conversão</h3>
              <ul className="bonus-features">
                <li>✅ Script direto da gringa (CONVERTE DEMAIS)</li>
                <li>✅ Completamente adaptado para o Brasil e funciona para qualquer nicho</li>
                <li>✅ Gatilhos mentais e truques psicológicos que hipnotizam visitantes</li>
                <li>✅ Instruções completas de personalização para seu produto/nicho</li>
              </ul>
              <p className="bonus-highlight">💰 Script Original: Paguei US$127 dólares (~R$700) - Agora adaptado e GRÁTIS para você!</p>
              <div className="bonus-value">
                <span className="bonus-price-old">VALOR: R$19,90</span>
                <span className="bonus-price-free">GRÁTIS para você hoje!</span>
              </div>
            </div>
          </div>

          {/* Bônus 3 - Comunidade */}
          <div className="bonus-card">
            <div className="bonus-image-wrapper">
              <img src="https://static.lumi.new/f9/f9524eef5fd0c15a4bfff24f94de5bee.webp" alt="Comunidade Mestre do Lovable" className="bonus-image" />
            </div>
            <div className="bonus-content">
              <h3 className="bonus-title">👥 Acesso à Comunidade VIP de usuários da Extensão</h3>
              <ul className="bonus-features">
                <li>✅ Interaja com outros desenvolvedores que usam a extensão</li>
                <li>✅ Peça dicas, ajuda e feedback dos seus projetos</li>
                <li>✅ Compartilhe experiências e aprenda com a comunidade</li>
                <li>✅ Acesso exclusivo a conteúdos e atualizações em primeira mão</li>
              </ul>
              <div className="bonus-value">
                <span className="bonus-price-old">VALOR: R$97,00</span>
                <span className="bonus-price-free">GRÁTIS para você hoje!</span>
              </div>
            </div>
          </div>

          {/* Bônus 4 - Bíblia do Lovable */}
          <div className="bonus-card">
            <div className="bonus-image-wrapper">
              <img src="https://static.lumi.new/21/218441438c40e5b7ce0ab7e4f7bc8f9e.webp" alt="A Bíblia do Lovable" className="bonus-image" />
            </div>
            <div className="bonus-content">
              <h3 className="bonus-title">📖 A Bíblia do Lovable</h3>
              <p className="bonus-description">101 HACKS E PROMPTS QUE VÃO AGILIZAR SEUS PROJETOS NO LOVABLE</p>
              <ul className="bonus-features">
                <li>✅ Prompts testados e comprovados que funcionam imediatamente, sem tentativa e erro</li>
                <li>✅ Prompts secretos para debugging que resolvem 99% dos problemas comuns em segundos</li>
                <li>✅ Prompts com fórmulas exclusivas para criar interfaces deslumbrantes sem conhecimento de design</li>
                <li>✅ Prompts para integração de APIs que economizam dias de trabalho</li>
                <li>✅ Prompts para desenvolvimento multi-plataforma que funcionam em qualquer dispositivo</li>
                <li>✅ Prompts para otimização de desempenho que fazem suas aplicações rodarem até 3x mais rápido</li>
                <li>✅ Prompts de validação de entrada que eliminam bugs antes mesmo de aparecerem</li>
                <li>✅ Prompts para implementar autenticação segura sem conhecimento avançado de segurança</li>
                <li>✅ Estratégias para monetização que transformam projetos pessoais em fontes de renda</li>
              </ul>
              <div className="bonus-value">
                <span className="bonus-price-old">VALOR: R$47,00</span>
                <span className="bonus-price-free">GRÁTIS para você hoje!</span>
              </div>
            </div>
          </div>

          {/* Bônus 5 - 101 Scripts */}
          <div className="bonus-card">
            <div className="bonus-image-wrapper">
              <img src="https://static.lumi.new/b6/b6cc23842225c8527a9587fee246ea89.webp" alt="101 Scripts de Prospecção" className="bonus-image" />
            </div>
            <div className="bonus-content">
              <h3 className="bonus-title">📝 101 Scripts Prontos para Usar</h3>
              <ul className="bonus-features">
                <li>✅ Scripts que eu mesmo uso para abordar donos de lojas</li>
                <li>✅ Minhas abordagens com ligação, call, email</li>
                <li>✅ Estratégias que aplico no Instagram e LinkedIn</li>
                <li>✅ Textos que uso na prática e que realmente convertem</li>
              </ul>
              <p className="bonus-highlight">💼 Para quem tem dúvida: "O que eu falo?" na hora de prospectar. Você só vai precisar adaptar ao seu projeto/nicho/negócio e começar a usar. No mínimo seu primeiro cliente em 7 dias!</p>
              <div className="bonus-value">
                <span className="bonus-price-old">VALOR: R$39,90</span>
                <span className="bonus-price-free">GRÁTIS para você hoje!</span>
              </div>
            </div>
          </div>
        </div>

        <div className="bonuses-total">
          <p className="bonuses-total-text">
            <span className="bonuses-total-label">VALOR TOTAL DOS BÔNUS:</span>
            <span className="bonuses-total-price">R$ 233,60</span>
          </p>
          <p className="bonuses-total-free">🎉 TODOS OS BÔNUS GRÁTIS

          </p>
        </div>
      </div>
    </section>);

}